import { get } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { LegacyCardStack } from "@shared/models/card-stack"
import type { Comment } from "@shared/models/comment"
import FindManyAltogether from "cc-frontend/helpers/find-many-altogether"
import type LessonEditor from "cc-frontend/services/lesson-editor"
import { use } from "ember-could-get-used-to-this"
import styles from "./lesson-comments.module.css"

interface Sig {
  Args: {
    lesson: LegacyCardStack
  }
  Element: HTMLDivElement
}

export default class Comments extends Component<Sig> {
  readonly styles = styles

  @service lessonEditor!: LessonEditor

  @use allComments = new FindManyAltogether(() => [
    "comment",
    get(this.args.lesson.attributes, "commentIds"),
  ])

  get hasComments(): boolean {
    return this.viewableComments.length > 0
  }

  get viewableComments(): Comment[] {
    if (get(this.allComments, "content") === null) return []

    return get(this.allComments, "content")!.filter(
      (comment) =>
        comment &&
        comment.meta.permissions.includes("can-view-comment") &&
        !get(comment.attributes, "deletedAt")
    )
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::CardStacks::Lesson::LessonComments": typeof Comments
  }
}
